document.addEventListener("DOMContentLoaded", function () {
  let wrapper = document.querySelector(".bm-product-comparison-wrapper");
  let scrollContainer = wrapper.querySelector(".bm-product-comparison-table");
  let singleCol = wrapper.querySelector(".bm-product-comparison-table__col.summary");
  let btnTarget = wrapper.querySelector(".bm-product-comparison-table__row");
  let prevButton = wrapper.querySelector('[aria-label="Previous"]');
  let nextButton = wrapper.querySelector('[aria-label="Next"]');
  let startX = 0;
  let endX = 0;

  // scroll button position adjustment
  function updateScrollButtons(reset = false) {
    let scrollLeft = scrollContainer.scrollLeft;
    let scrollWidth = scrollContainer.scrollWidth;
    let clientWidth = scrollContainer.clientWidth;

    // check if there is any content to scroll left
    if (scrollLeft > 0) {
      prevButton.classList.add("active");
    } else {
      prevButton.classList.remove("active");
    }

    // check if there is any content to scroll right
    if (scrollLeft + clientWidth < scrollWidth - 1) {
      nextButton.classList.add("active");
    } else {
      nextButton.classList.remove("active");
    }

    // sync button top position
    let btnTop = btnTarget.clientHeight;
    prevButton.style.top = btnTop + "px";
    nextButton.style.top = btnTop + "px";

    // reset scroll to start position
    if (reset == true) {
      scrollContainer.scrollBy({
        left: -scrollLeft,
        top: 0,
        behavior: 'smooth'
      });
    }
  }

  // scroll one item left axis
  function scrollToLeft() {
    let colOffsetWidth = singleCol.offsetWidth;
    scrollContainer.scrollBy({
      left: -colOffsetWidth,
      top: 0,
      behavior: 'smooth'
    });
  }

  // scroll one item right axis
  function scrollToRight() {
    let colOffsetWidth = singleCol.offsetWidth;
    scrollContainer.scrollBy({
      left: colOffsetWidth,
      top: 0,
      behavior: 'smooth'
    });
  }

  // handle swipe
  function handleSwipe(diff) {
    if (Math.abs(diff) < 20) return;

    if (diff > 0) {
      scrollToLeft();
    } else {
      scrollToRight();
    }

    scrollContainer.classList.remove("dragging");
  }

  // handle drag and touch events
  function touchDragEvents() {
    // For touch devices
    scrollContainer.addEventListener("touchstart", function (e) {
      startX = e.touches[0].clientX;
      scrollContainer.classList.add("dragging");
    });
    scrollContainer.addEventListener("touchmove", function (e) {
      currentX = e.touches[0].clientX;
      handleSwipe(currentX - startX);
    });
    scrollContainer.addEventListener("touchend", function () {
      scrollContainer.classList.remove("dragging");
    });

    // For mouse drag on desktop
    let isMouseDown = false;
    scrollContainer.addEventListener("mousedown", function (e) {
      isMouseDown = true;
      startX = e.clientX;
      scrollContainer.classList.add("dragging");
    });
    scrollContainer.addEventListener("mousemove", function (e) {
      if (!isMouseDown) return;
      currentX = e.clientX;
      handleSwipe(currentX - startX);
    });
    scrollContainer.addEventListener("mouseup", function () {
      if (!isMouseDown) return;
      isMouseDown = false;
      scrollContainer.classList.remove("dragging");
    });
  }


  // arrow initial check and event listeners
  updateScrollButtons();
  scrollContainer.addEventListener("scroll", updateScrollButtons);
  window.addEventListener("resize", updateScrollButtons.bind(null, true));

  // btn event listener
  prevButton.addEventListener("click", scrollToLeft);
  nextButton.addEventListener("click", scrollToRight);

  // drag and touch event
  touchDragEvents();
})